module.exports = __webpack_public_path__ + "static/media/MMOCategory.40b3647a.pdf";